<template>
  <div class="cs-app">
    <router-view></router-view>

    <div v-if="isShowFormModal" class="modal-form modal-form-show">
      <component :is="cModalComponent"></component>
    </div>

    <div v-if="isShowPolicyModal" class="modal-form modal-form-show">
      <modal-policy></modal-policy>
    </div>
    <div v-if="isShowTermModal" class="modal-form modal-form-show">
      <modal-term></modal-term>
    </div>

    <modal-global
      v-if="isShowGlobalModal"
      :isShowCancel="gModalData.isShowCancel"
      @onCancel="onClose"
      @onConfirm="onConfirm"
    >
      <template v-slot:title>
        <span>{{ gModalData.title }}</span>
      </template>
      <template v-slot:description>
        <p>{{ gModalData.content }}</p>
      </template>
    </modal-global>

    <div v-if="isLoader" class="view-loader" :class="!isViewLoader ? 'view-loader-hidden' : ''">
      <div class="loader-boxs">
        <div class="scene">
          <div class="plane">
            <div class="cube cube--0">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--0"></div>
            <div class="cube cube--1">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--1"></div>
            <div class="cube cube--2">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--2"></div>
            <div class="cube cube--3">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--3"></div>
            <div class="cube cube--4">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--4"></div>
            <div class="cube cube--5">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--5"></div>
            <div class="cube cube--6">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--6"></div>
            <div class="cube cube--7">
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
              <div class="cube__side"></div>
            </div>
            <div class="shadow shadow--7"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {watch, ref} from "vue";
import {storeToRefs} from "pinia";
import {CommonStore} from "./store/common-store";
import ModalGlobal from "./views/modals/modal-global.vue";
import ModalPolicy from "./views/modals/modal-privacy-policy.vue";
import ModalTerm from "./views/modals/modal-term.vue";

const commonStore = CommonStore();
const {
  isViewLoader,
  isShowGlobalModal,
  gModalData,
  isShowFormModal,
  isShowPolicyModal,
  isShowTermModal,
  cModalComponent,
} = storeToRefs(commonStore);

const isLoader = ref(false);

watch(isViewLoader, (value) => {
  if (value) {
    isLoader.value = true;
  } else {
    setTimeout(() => {
      isLoader.value = false;
    }, 100);
  }
});

const onConfirm = () => {
  const result = {
    modalName: gModalData.value.modalName,
    result: gModalData.value.result,
  };

  commonStore.setModalResult(result);
  commonStore.closeGlobalModal();
};

const onClose = () => {
  commonStore.closeGlobalModal();
};
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";

.view-loader {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 250, 0.7);
  transition: opacity 0.25s;

  &.view-loader-hidden {
    opacity: 0;
  }

  .scene {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
